import { ApolloLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { isWeb } from 'tamagui'
import { router } from 'expo-router'
import * as Sentry from '@sentry/react-native'
import NetInfo from '@react-native-community/netinfo'
import { EMPTY_PAGE_ERROR_CODE } from '@utils/apolloErrors'

export const createGraphqlErrorLink = (): ApolloLink =>
  onError(({ graphQLErrors, operation, forward, networkError }) => {
    if (networkError) {
      console.error('GraphQL Network Error:', {
        message: networkError.message,
        operation: operation.operationName,
        variables: operation.variables,
        networkError,
      })

      NetInfo.refresh()

      Sentry.captureException(networkError, {
        tags: {
          type: 'graphql_network_error',
          operation: operation.operationName,
        },
        extra: {
          variables: JSON.stringify(operation.variables),
          message: networkError.message,
        },
      })
    }

    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        if (err.message === "Couldn't find User without an ID") {
          if (!isWeb) {
            router.replace('/users/sign_in')
          }
          return forward(operation)
        }
        if (err.message === 'Token is invalid') {
          return
        }
        // `empty_page` não é reenviado: a resposta do core é a mesma em toda
        // tentativa (o offset continua além do fim da lista), então o reenvio só
        // dobrava a chamada, e quem precisa VER esse erro é o hook, para
        // encerrar a paginação. O `return` mantém o curto-circuito da varredura
        // que o reenvio fazia — sem ele, uma resposta com `empty_page` mais um
        // erro de sessão cairia no redirect de login acima. `unauthorized`
        // também não entra aqui, pelo mesmo motivo (a matrícula não dá acesso ao
        // curso em tentativa nenhuma).
        if (err.extensions?.code === EMPTY_PAGE_ERROR_CODE) return
      }
    }
  })
